const EMAIL_REGEX_FORMAT = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9]+.[a-z]+\.([a-z]+)?$/i;

export default function emailValidation(email: string): boolean {
  if (EMAIL_REGEX_FORMAT.test(email)) return true;

  return false;
}
